import { render, staticRenderFns } from "./IdelTimeIndicatorThresholdTableButton.vue?vue&type=template&id=4ca13cd5&"
import script from "./IdelTimeIndicatorThresholdTableButton.vue?vue&type=script&lang=js&"
export * from "./IdelTimeIndicatorThresholdTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports